/**
 * This is for web session id generation and refreshing
 * @see https://wiki.coupang.net/display/PPF/a.+detailed+design#a.detaileddesign-Session
 */

import UUID from './UUID';
import ConsoleLog from './ConsoleLog';
import Cookie from './Cookie'

const WEB_SESSION = 'web-session-id';
const THITY_MINUTES = 30 * 60 * 1000;
const TAG = 'WEB_SESSION';

/**
 * get web session from cookie
 * @returns {WebSession | null}
 */
export function getWebSessionIdFromCookie() {
  return Cookie.getCookie(WEB_SESSION);
}

/**
 * set web session in cookie
 * @param webSession
 */
export function setWebSessionId(sessionId:string, expires:Date) {
  Cookie.setCookie(WEB_SESSION, sessionId, expires);
}

/**
 * update web session in cookie, if the session id is expired then update a new one or refresh the expires
 * @return {WebSession} the new web session
 */
export default function updateWebSessionIdIfNeeded() {
  ConsoleLog.d(TAG, 'start update web session id');
  const webSessionId = getWebSessionIdFromCookie();
  ConsoleLog.d(TAG, `web session is ${JSON.stringify(webSessionId)}`);

  let newWebSessionId;
  if (!webSessionId) {
    // if the session id is not exist, generate a new one
    ConsoleLog.d(TAG, 'web session is not exist, generate a new web session id');
    newWebSessionId = UUID.generate();
  } else {
    // if the session id is not expired, refresh the expires
    ConsoleLog.d(TAG, 'refresh the expires of web session id');
    newWebSessionId = webSessionId;
  }
  const expires = new Date(Date.now() + THITY_MINUTES);
  ConsoleLog.d(TAG, `update new web session: ${JSON.stringify(newWebSessionId)}`);
  setWebSessionId(newWebSessionId, expires);
  return newWebSessionId;
}